import Dexie, { type Table } from 'dexie'
import type { HistorySegment, PositionFix } from '@cht/shared'
import type { StoredMedia } from './capture/media-store.js'
import type { TrailDraft } from './geo/trail-recorder.js'
import type { QueuedUpload } from './sync/upload-machine.js'
import type { StoredPin } from './pins/pin-store.js'

export interface HistoryCacheEntry {
  id: string
  propertyId: string
  userId: string
  from: number
  to: number
  cachedAt: number
  segments: HistorySegment[]
}

export class CountryHouseDB extends Dexie {
  positions!: Table<PositionFix, string>
  trailDrafts!: Table<TrailDraft, string>
  media!: Table<StoredMedia, string>
  pins!: Table<StoredPin, string>
  uploads!: Table<QueuedUpload, string>
  historyCache!: Table<HistoryCacheEntry, string>

  constructor(name = 'country-house-trails') {
    super(name)
    this.version(1).stores({
      positions: 'id, userId, recordedAt',
      trailDrafts: 'id, authorId, status, updatedAt',
      media: 'id, authorId, capturedAt',
      pins: 'id, authorId, category, updatedAt',
      uploads: 'id, state, nextAttemptAt'
    })
    // Multi-property: local records carry the property they belong to, and the
    // compound indexes let a screen read one property's data without scanning.
    this.version(2).stores({
      positions: 'id, propertyId, userId, recordedAt, [propertyId+recordedAt]',
      trailDrafts: 'id, propertyId, authorId, status, updatedAt',
      media: 'id, propertyId, authorId, capturedAt, [propertyId+capturedAt]',
      pins: 'id, propertyId, authorId, category, updatedAt, [propertyId+updatedAt]',
      uploads: 'id, propertyId, state, nextAttemptAt'
    })
    this.version(3).stores({
      pins: 'id, propertyId, authorId, category, syncState, updatedAt, [propertyId+updatedAt], [propertyId+syncState]'
    })
    this.version(4).stores({
      media: 'id, propertyId, authorId, kind, syncState, capturedAt, [propertyId+capturedAt], [propertyId+syncState]'
    })
    this.version(5).stores({
      historyCache: 'id, propertyId, userId, cachedAt, [propertyId+cachedAt]'
    })
  }
}

export const db = new CountryHouseDB()
